import React, { useEffect, useState } from "react";
import "./MarketPlace.css";
import RecentListing from "../Recent Listning/RecentListing";
import RecentSales from "../Recent Sales/RecentSales";
import Chart from "react-apexcharts";
import {
  getStats
} from "../contractInteraction/contractInteraction";

const Marketplace = () => {

  const [stats, setStats] = useState({});
  const getStatistics = async () => {
    const tempStats = await getStats();
    setStats(tempStats);
  }

  const options = {
    xaxis: {
      categories: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    },
    colors: ["#D501FA", "#ffffff", "#ffffff"], // Specify colors for each series
    chart: {
      toolbar: {
        show: false, // Hide the toolbar (including zoom icons and other controls)
      },
    },
    zoom: {
      enabled: false, // Disable zoom functionality
    },
  };
  const seriesTotalSales = [
    {
      name: "s1",
      data: [0, stats?.totalSales ? Number(stats?.totalSales) : 0],
    },
  ];
  const seriesLandSold = [
    {
      name: "s1",
      data: [0, stats?.landSold ? Number(stats?.landSold) : 0],
    },
  ];
  const seriesTotalRented = [
    {
      name: "s1",
      data: [0, stats?.totalRented ? Number(stats?.totalRented) : 0],
    },
  ];
  const seriesTotalRentListed = [
    {
      name: "s1",
      data: [0, String(stats?.totalRentListed) ? Number(stats?.totalRentListed) : 0],
    },
  ];
  const seriesAvailableLands = [
    {
      name: "s1",
      data: [1900, String(stats?.availableLands) ? Number(stats?.availableLands) : 0],
    },
  ];



  useEffect(() => {
    getStatistics();
  }, [])

  useEffect(() => {
    console.log("gg", stats);
  }, [stats])
  return (
    <>
      <div className="marketplace-wrapper">
        <div className="recent-listing">
          <div className="recent-listing-content">
            <div className="head-and-para graph">
              <div className="left">
                <h1>Overall Stats</h1>
              </div>
              <div className="right">
                <button>24h</button>
                <button>7D</button>
                <button>30D</button>
              </div>
            </div>
            <div className="graph-parent">
              <div className="rentel-graph ">
                <Chart
                  options={options}
                  series={seriesTotalSales}
                  width="100%"
                  height="242px"
                  type="area"
                />
                <p>
                  <span className="one text-light-grey">Total Sales</span>
                  <span className="two ">{stats?.totalSales ? stats?.totalSales : "Fetching..."}</span>
                </p>
              </div>
              <div className="rentel-graph  ">
                <Chart
                  options={options}
                  series={seriesLandSold}
                  width="100%"
                  height="242px"
                  type="area"
                />
                <p>
                  <span className="one text-light-grey">land sold</span>
                  <span className="two ">{stats?.landSold ? stats?.landSold : "Fetching..."}</span>
                </p>
              </div>
              <div className="rentel-graph ">
                <Chart
                  options={options}
                  series={seriesTotalRented}
                  width="100%"
                  height="242px"
                  type="area"
                />
                <p>
                  <span className="one text-light-grey">Total rented out</span>
                  <span className="two ">{stats?.totalRented ? stats?.totalRented : "Fetching..."}</span>
                </p>
              </div>
              <div className="rentel-graph  ">
                <Chart
                  options={options}
                  series={seriesTotalRentListed}
                  width="100%"
                  height="242px"
                  type="area"
                />
                <p>
                  <span className="one text-light-grey">Looking for Rent</span>
                  <span className="two ">{String(stats?.totalRentListed) ? stats?.totalRentListed : "Fetching..."}</span>
                </p>
              </div>
              <div className="rentel-graph  ">
                <Chart
                  options={options}
                  series={seriesAvailableLands}
                  width="100%"
                  height="242px"
                  type="area"
                />
                <p>
                  <span className="one text-light-grey">aVAILABLe land</span>
                  <span className="two ">{String(stats?.availableLands) ? stats?.availableLands : "Fetching..."}</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <RecentListing hide="d-none"/>
        <RecentSales hide="d-none" head="Recent sales"/>
        <RecentSales hide="d-none" head="Recent Rent"/>

        {/* <RecentSales /> */}
        <div className="bottom-light w-100">
          <img
            src="\assets\images\Market Place images\BottomLight.png"
            alt=""
            className="img-fluid"
          />
        </div>

        <div className="partners">
          <div className="heading">
            <h1>Partners</h1>
          </div>
          <div className="line-1">
            <a href="#">
              <img
                src="\assets\images\Market Place images\Maestro.svg"
                className="img-fluid"
                alt=""
              />
            </a>
            <a href="#">
              <img
                src="\assets\images\Market Place images\Klarna.svg"
                alt=""
                className="img-fluid"
              />
            </a>
            <a href="#">
              <img
                src="\assets\images\Market Place images\ShopPay.svg"
                className="img-fluid"
                alt=""
              />
            </a>
            <a href="#">
              <img
                src="\assets\images\Market Place images\AmericanExpress.svg"
                className="img-fluid"
                alt=""
              />
            </a>
            <a href="#">
              <img
                src="\assets\images\Market Place images\OpenSea.svg"
                className="img-fluid"
                alt=""
              />
            </a>

            <a href="#">
              <img
                src="\assets\images\Market Place images\Paypal.svg"
                alt=""
                className="img-fluid"
              />
            </a>
            <a href="#">
              <img
                src="\assets\images\Market Place images\Square.svg"
                alt=""
                className="img-fluid"
              />
            </a>
            <a href="#">
              <img
                src="\assets\images\Market Place images\ethereum.svg"
                alt=""
                className="img-fluid"
              />
            </a>
            <a href="#">
              <img
                src="\assets\images\Market Place images\Alipay.svg"
                alt=""
                className="img-fluid"
              />
            </a>
            <a href="#">
              <img
                src="\assets\images\Market Place images\metamask.svg"
                alt=""
                className="img-fluid"
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Marketplace;
